<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">Editar Instalação</h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Instalações',
                href: `/#/user/${viewData.userId}/installations/${viewData.accountId}`,
              },
              {
                text: 'Editar Instalação',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Tensão"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.tension"
                      :options="viewData.tensions"
                      :state="isOk('tension')"
                      class="mb-3"
                    >
                      <option disabled value>Selecione uma tensão</option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('tension')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Modalidade tarifária"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.tariffModality"
                      :options="viewData.modalities"
                      :state="isOk('tariffModality')"
                      class="mb-3"
                    >
                      <option disabled value>
                        Selecione uma modalidade tarifária
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('tariffModality')
                    }}</b-form-invalid-feedback>
                  </b-form-group></b-col
                >
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    label="Classe"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.class"
                      :options="viewData.classes"
                      :state="isOk('class')"
                      class="mb-3"
                    >
                      <option disabled value>Selecione uma classe</option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('class')
                    }}</b-form-invalid-feedback>
                  </b-form-group></b-col
                >
                <b-col
                  ><b-form-group
                    id="input-group-1"
                    label="Tipo de ligação"
                    label-for="input-1"
                  >
                    <b-form-select
                      v-model="state.connectionType"
                      :options="viewData.connectionTypes"
                      :state="isOk('connectionType')"
                      class="mb-3"
                    >
                      <option disabled value>
                        Selecione um tipo de ligação
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{
                      getError('connectionType')
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-group
                id="input-group-1"
                label="Número da Instalação"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.installationNumber"
                  placeholder="Informe o Número da Instalação"
                  :state="isOk('installationNumber')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('installationNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="CEP" label-for="input-1">
                <b-form-input
                  v-model="state.zipCode"
                  placeholder="Informe o CEP da instalação"
                  :state="isOk('zipCode')"
                  v-mask="['#####-###']"
                  @blur="fillCompleteAddress($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('zipCode')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Distribuidora"
                label-for="input-1"
              >
                <v-select
                  @search="search"
                  :options="viewData.powerPlants"
                  v-model="state.powerPlantId"
                  label="label"
                  placeholder="Pesquise por uma distribuidora..."
                >
                  <div slot="no-options">Nenhum resultado encontrado.</div>
                </v-select>

                <b-form-invalid-feedback>{{
                  getError('socialNumber')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <!-- <b-form-group
                id="input-group-1"
                label="Distribuidora"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.distributor"
                  placeholder="Informe a Distribuidora"
                  :state="isOk('distributor')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('distributor')
                }}</b-form-invalid-feedback>
              </b-form-group> -->

              <b-form-group
                id="input-group-1"
                label="Endereço"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.address"
                  placeholder="Informe o Endereço da instalação"
                  :state="isOk('address')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('address')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Numero"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.number"
                  placeholder="Informe o Número da instalação"
                  :state="isOk('number')"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('number')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Bairro"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.district"
                  placeholder="Informe o Bairro da instalação"
                  :state="isOk('district')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('district')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Cidade"
                label-for="input-1"
              >
                <b-form-input
                  v-model="state.city"
                  placeholder="Informe a Cidade da instalação"
                  :state="isOk('city')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('city')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Estado"
                label-for="input-1"
              >
                <b-form-select
                  v-model="state.state"
                  :options="viewData.states"
                  :state="isOk('state')"
                  class="mb-3"
                >
                  <option disabled value>Selecione um estado</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('state')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-1" label="Status">
                <b-form-select
                  v-model="state.status"
                  :options="viewData.status"
                  :state="isOk('status')"
                  class="mb-3"
                >
                  <option disabled value>Selecione um status</option>
                </b-form-select>
                <b-form-invalid-feedback>{{
                  getError('status')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import * as _ from 'lodash';
import StatesJson from '../../vue/estados.json';

const API = new Api();

export default {
  name: 'installations-edit',
  data: function() {
    return {
      state: {
        address: '',
        city: '',
        couponDescription: '',
        couponValue: null,
        couponPercentage: '',
        installationNumber: null,
        distributor: '',
        district: '',
        number: 0,
        state: '',
        zipCode: '',
        powerPlantId: 0,
        tension: '',
        tariffModality: '',
        class: '',
        connectionType: '',
        status: '',
      },
      viewData: {
        loading: false,
        states: [],
        errors: [],
        accountId: 0,
        userId: 0,
        id: 0,
        powerPlants: [],
        tensions: [],
        modalities: [],
        classes: [],
        connectionTypes: [],
        status: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    this.viewData.states = StatesJson.estados;

    this.viewData.status = [
      { value: 'ACTIVE', text: 'Ativo' },
      { value: 'INACTIVE', text: 'Inativo' },
      { value: 'WAITING_APPROVAL', text: 'Aguardando aprovação' },
      { value: 'REMOVED', text: 'Removido' },
    ];

    this.viewData.tensions = [
      { value: '1_BAIXA', text: '1_BAIXA' },
      { value: '2_MEDIA', text: '2_MEDIA' },
      { value: '3_ALTA', text: '3_ALTA' },
    ];
    this.viewData.modalities = [
      { value: 'B1', text: 'B1' },
      { value: 'B2', text: 'B2' },
      { value: 'B3', text: 'B3' },
      { value: 'A4_Verde', text: 'A4_Verde' },
    ];

    this.viewData.classes = [
      {
        value: '1_RESIDENCIAL',
        text: '1_RESIDENCIAL',
      },
      {
        value: '2_COMERCIAL',
        text: '2_COMERCIAL',
      },
      {
        value: '3_INDUSTRIAL',
        text: '3_INDUSTRIAL',
      },
      {
        value: '4_RURAL',
        text: '4_RURAL',
      },
      {
        value: '5_PODER_PUBLICO',
        text: '5_PODER_PUBLICO',
      },
      {
        value: '6_SERVICO_PUBLICO',
        text: '6_SERVICO_PUBLICO',
      },
    ];

    this.viewData.connectionTypes = [
      { value: '1_MONOFASICO', text: '1_MONOFASICO' },
      { value: '2_BIFASICO', text: '2_BIFASICO' },
      { value: '3_TRIFASICO', text: '3_TRIFASICO' },
    ];

    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/installation/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.state.couponValue = parseFloat(this.state.couponValue);
        this.state.powerPlantId = result.model.powerPlant;

        this.viewData.loading = false;
        this.viewData.accountId = result.model.accountId;
        this.viewData.userId = result.model.userId;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    async search(search) {
      if (!search) {
        this.viewData.powerPlants = [];
        return;
      }

      try {
        const result = await API.post('/execute', {
          path: '/power-plants-search?search=' + search,
          method: 'get',
        });
        this.viewData.powerPlants = result.model || [];
      } catch (ex) {
        this.viewData.powerPlants = [];
      }
    },
    async fillCompleteAddress() {
      if (this.isZipCode(this.state.zipCode)) {
        let response = await this.$http.get(
          `https://viacep.com.br/ws/${this.state.zipCode}/json`,
        );

        if (response.statusCode === 200 && !response.error) {
          this.state.address = response.body.logradouro;
          this.state.district = response.body.bairro;
          this.state.city = response.body.localidade;
          this.state.state = response.body.uf;
        }
      }
    },
    isZipCode(zipCode) {
      let re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

      if (re.test(zipCode)) {
        return true;
      } else {
        return false;
      }
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async save() {
      let data = {
        address: this.state.address,
        city: this.state.city,
        couponDescription: this.state.couponDescription,
        couponValue: this.state.couponValue ? this.state.couponValue : 0,
        couponPercentage: this.state.couponPercentage
          ? this.state.couponPercentage
          : 0,
        installationNumber: this.state.installationNumber,
        distributor: this.state.distributor,
        district: this.state.district,
        number: this.state.number ? this.state.number : 0,
        state: this.state.state,
        zipCode: this.state.zipCode.replace('-', ''),
        powerPlantId: this.state.powerPlantId.id,
        tension: this.state.tension,
        tariffModality: this.state.tariffModality,
        class: this.state.class,
        connectionType: this.state.connectionType,
        status: this.state.status,
      };

      try {
        const result = await API.post('/execute', {
          path: `/user/${this.viewData.accountId}/installation/${this.viewData.id}`,
          method: 'put',
          data: data,
        });
        this.$router.push(
          `/user/${this.viewData.userId}/installations/${this.viewData.accountId}`,
        );
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {},
};
</script>
